var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5737,
    cy: 66.5737,
    r: 66.5737,
    fill: "#710D10"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2529 78.2814H47.0581C49.2135 78.2814 50.9607 80.0287 50.9607 82.184V89.9892C50.9607 92.1446 49.2135 93.8918 47.0581 93.8918H39.2529V66.5736C39.2529 51.4862 51.4837 39.2555 66.5711 39.2555C81.6585 39.2555 93.8893 51.4862 93.8893 66.5736V93.8918H86.0841C83.9288 93.8918 82.1815 92.1446 82.1815 89.9892V82.184C82.1815 80.0287 83.9288 78.2814 86.0841 78.2814H93.8893",
    stroke: "white",
    strokeWidth: 6.50433,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatIcon);
export default __webpack_public_path__ + "static/media/ai-chat-icon.0ceb1f90bd59eff4bd3120d1e465523a.svg";
export { ForwardRef as ReactComponent };